 /* 
	*  2008-2016 - Copyright Skyrin Corporation - All rights reserved.
	*  Created on: Oct 31, 2016
	*  Author: René Stein <rene@skyrin.com>
	*/

import React from 'react';

import List from './List';

import exception from '../../../exception';
import request from 'arcdynamic-request';

export default React.createClass({
	getDefaultProps() {
		return {
			limitCount: 20,
		};
	},
	getInitialState(){
		return {
			purchases: [],
			total: 0
		};
	},
	_fetch(query) {
		const { search = null, page = 1, order = 'desc' } = query;

		this.setState({purchases:[]});

		request(this.props.deployment.path.store.replace('<storeCode>',this.props.store.code), {
			service: 'cart',
			action: 'Purchase.get',
			options: {
				flag: {
					billing: true,
					user: true
				},
				filter: {
					search
				},
				order: order ? [order] : null,
				limit: {
					count: this.props.limitCount,
					offset: (this.props.limitCount * page) - this.props.limitCount
				},
				count: 2
			}
		}).then((res)=>{
			this.setState({
				purchases:res.data||[],
				total: res.count || 0
			});
		}).catch(exception);
	},
	componentDidMount(){
		this._fetch(this.props.location.query);
	},
	componentWillReceiveProps(nextProps){
		this._fetch(nextProps.location.query);
	},
	render() {
		return (
			<List
				deployment={this.props.deployment} 
				location={this.props.location} 
				limitCount={this.props.limitCount} 
				store={this.props.store}
				{...this.state}
			/>
		);
	}
});
